import { BrowserRouter as Router, Routes, Route } from "react-router";
import { AuthProvider } from '@getmocha/users-service/react';
import { ThemeProvider } from '@/react-app/contexts/ThemeContext';
import { QueryProvider } from '@/shared/providers/QueryProvider';
import Landing from "@/react-app/pages/Landing";
import Dashboard from "@/react-app/pages/Dashboard";
import AuthCallback from "@/react-app/pages/AuthCallback";
import About from "@/react-app/pages/About";
import Contact from "@/react-app/pages/Contact";
import Login from "@/react-app/pages/Login";
import Register from "@/react-app/pages/Register";
import AdminDashboard from "@/react-app/pages/admin/AdminDashboard";
import UserManagement from "@/react-app/pages/admin/UserManagement";
import PackageManagement from "@/react-app/pages/admin/PackageManagement";
import DepositManagement from "@/react-app/pages/admin/DepositManagement";
import TransactionManagement from "@/react-app/pages/admin/TransactionManagement";
import Analytics from "@/react-app/pages/admin/Analytics";
import AdminSettings from "@/react-app/pages/admin/AdminSettings";
import FinancialOverview from "@/react-app/pages/admin/FinancialOverview";
import Vault from "@/react-app/pages/admin/Vault";
import Profile from "@/react-app/pages/Profile";
import Settings from "@/react-app/pages/Settings";
import TransactionsHistory from "@/react-app/pages/TransactionsHistory";
import PackagesInvested from "@/react-app/pages/PackagesInvested";
import Financials from "@/react-app/pages/Financials";
import ForgotPassword from "@/react-app/pages/ForgotPassword";
import ResetPassword from "@/react-app/pages/ResetPassword";
import Save from "@/react-app/pages/Save";
import Referrals from "@/react-app/pages/Referrals";
import Privacy from "@/react-app/pages/Privacy";
import Terms from "@/react-app/pages/Terms";
import Security from "@/react-app/pages/Security";
import WithdrawalManagement from "@/react-app/pages/admin/WithdrawalManagement";
import Cookies from "@/react-app/pages/Cookies";
import Notifications from "@/react-app/pages/admin/Notifications";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AppKitProvider } from "@/react-app/hooks/appKitProvider";
import { HelmetProvider } from 'react-helmet-async';



export default function App() {
  return (
    <HelmetProvider>
      <AppKitProvider>
        <QueryProvider>
          <ThemeProvider>
            <AuthProvider>
              <Router>
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/auth/callback" element={<AuthCallback />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/save" element={<Save />} />
                  <Route path="/financials" element={<Financials />} />
                  <Route path="/transactions" element={<TransactionsHistory />} />
                  <Route path="/packages" element={<PackagesInvested />} />
                  <Route path="/referrals" element={<Referrals />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/security" element={<Security />} />
                  <Route path="/cookies" element={<Cookies />} />

                  {/* Admin Routes */}
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/users" element={<UserManagement />} />
                  <Route path="/admin/packages" element={<PackageManagement />} />
                  <Route path="/admin/deposits" element={<DepositManagement />} />
                  <Route path="/admin/transactions" element={<TransactionManagement />} />
                  <Route path="/admin/analytics" element={<Analytics />} />
                  <Route path="/admin/financial-overview" element={<FinancialOverview />} />
                  <Route path="/admin/settings" element={<AdminSettings />} />
                  <Route path="/admin/withdrawals" element={<WithdrawalManagement />} />
                  <Route path="/admin/notifications" element={<Notifications />} />
                  <Route path="/admin/vault" element={<Vault />} />
                </Routes>
              </Router>
              <ToastContainer position="top-right" autoClose={3000} />
            </AuthProvider>
          </ThemeProvider>
        </QueryProvider>
      </AppKitProvider>
    </HelmetProvider>
  );
}
